module.exports = __webpack_public_path__ + "img/gb13871-92_105x130x12.prt.2a71e8b9.jpg";